import x from './x'

export default ({ width }) => [x({ width }), 1]
